import React from 'react';
import { useTranslation } from 'react-i18next';

import certificate1 from '../../assets/images/ceritificate_pic_1.png';
import certificate2 from '../../assets/images/ceritificate_pic_2.png';

const Certification = () => {
  const { t } = useTranslation();

  const certifications = [
    {
      image: certificate1,
      description: t('certificate_description_1'),
    },
    {
      image: certificate2,
      description: t('certificate_description_2'),
    },
  ];

  return (
    <section className="certification">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center">
            <div className="content_wrapper">
              <h2>{t('certifications_heading')}</h2>
            </div>
          </div>
        </div>
        <div className="affilation_box">
          {certifications.map((cert, index) => (
            <div className="box_wrapper" key={index}>
              <div className="icon">
                <img
                  src={cert.image}
                  alt={`Certificate ${index + 1}`}
                  style={{
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                  }}
                />
              </div>
              <div className="desc_info">
                <p>{cert.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certification;
